import { ConfirmDeletePopup, usePopupFormManager } from 'features/nekst-widgets';

import { EditAvatarForm } from './EditAvatarForm';
import { useAvatarService } from "nekst-api";

interface ConfirmDeleteAvatarPopupProps {
  personId: number;
}

export function ConfirmDeleteAvatarPopup(props: ConfirmDeleteAvatarPopupProps) {
  const avatarService = useAvatarService();

  return (
    <ConfirmDeletePopup
      deleteFunc={() => avatarService.removeAvatar(props.personId)}
      message="Are you sure you want to delete the photo?"
    />
  );
}


export function useAvatarPopups() {
  const popupManager = usePopupFormManager();

  const openUploadForm = (personId: number) => {
    popupManager.openForm(<EditAvatarForm personId={personId} />);
  };

  const openConfirmDeletePopup = (personId: number) => {
    popupManager.openForm(<ConfirmDeleteAvatarPopup personId={personId} />);
  };

  return {
    openUploadForm,
    openConfirmDeletePopup,
  };
}
